module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result10-cb5bb1983c569460697206e1964e4646.png";